import { canv } from '@/canv/global.js'
import { textWidget } from '@/elements/text/text.js'
import {
    generateUID,
    lightOrDark,
    getNumberProperty,
    getStringProperty,
    getColorProperty,
} from '@/canv/utils.js';

export class tableWidgetCell  {

    constructor() {
        this.UID = generateUID();

        this.textPart = new textWidget(0, 0);

        this.textPart.menuTextSize(17, true);
        this.textPart.shapeMode = true;
        this.textPart.setKeepMinWidth(false);
    }


    updatePosition(startX, startY) {
        this.startX = startX;
        this.startY = startY;

        if (this.alignment == "left") {
            this.textPart.startX = this.startX + this.horizontalPadding;
            this.textPart.startY = this.startY + this.textPart.lines[0].textHeight + this.verticalPadding;
        } else if (this.alignment == "center") {
            this.textPart.startX = this.startX + this.width/2 - this.textPart.width/2;
            this.textPart.startY = this.startY + this.height/2 - this.textPart.height/2 + this.textPart.lines[0].textHeight;
        } else {
            this.textPart.startX = this.startX + this.width - this.horizontalPadding - this.textPart.width;
            this.textPart.startY = this.startY + this.textPart.lines[0].textHeight + this.verticalPadding;
        }

        this.textPart.updateDims();
    }


    // helpers

    isMergedCell() {
        return this.sectionWidth > 1;
    }




    // TryAction

    TryAction(type) {
        this.textPart.TryAction(type);
    }


    // Tools

    copyCellOptions(cell) {

        // копируем настройки текста
        this.textPart.fontSize = cell.textPart.fontSize;
        this.textPart.fontStyle = cell.textPart.fontStyle;
        this.textPart.fontColor = cell.textPart.fontColor;
        this.textPart.fontBold = cell.textPart.fontBold;
        this.textPart.fontStrike = cell.textPart.fontStrike;
        this.textPart.menuTextBulleted(cell.textPart.bullettedList, true);
        this.textPart.menuTextAlign(cell.textPart.align, true);

        this.alignment = cell.alignment;
        this.setBackgroundColor(cell.backgroundColor);
        this.sectionWidth = cell.sectionWidth;
    }



    // Draw

    clipCell() {
        canv.ctx.beginPath()
        canv.ctx.moveTo(this.startX, this.startY);
        canv.ctx.lineTo(this.startX + this.width, this.startY);
        canv.ctx.lineTo(this.startX + this.width, this.startY + this.height);
        canv.ctx.lineTo(this.startX, this.startY + this.height);
        canv.ctx.lineTo(this.startX, this.startY);

        canv.ctx.clip();
    }

    drawRoundedRect(x, y, w, h, cellRound) {
        //if (w < 2 * r) r = w / 2;
        //if (h < 2 * r) r = h / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x+cellRound["0"], y);
        canv.ctx.arcTo(x+w, y,   x+w, y+h, cellRound["1"]);
        canv.ctx.arcTo(x+w, y+h, x,   y+h, cellRound["2"]);
        canv.ctx.arcTo(x,   y+h, x,   y,   cellRound["3"]);
        canv.ctx.arcTo(x,   y,   x+w, y,   cellRound["0"]);
        canv.ctx.closePath();
    }

    draw(cellRound) {
        this.drawRoundedRect(this.startX, this.startY, this.width, this.height, cellRound);
        canv.ctx.fillStyle = this.backgroundColor;
        canv.ctx.strokeStyle = "#AEAEAE";
        canv.ctx.lineWidth = 1;
        canv.ctx.fill();
        canv.ctx.stroke();

        canv.ctx.save();
        this.clipCell();
        this.textPart.draw();
        canv.ctx.restore();
    }

    isOver() {
        var pt = canv.actionManager.getActionPoint();
        var x = pt.x;
        var y = pt.y;

        if (x >= this.startX && x <= this.startX + this.width && y >= this.startY && y <= this.startY + this.height) {
            return true;
        }


        return false;
    }

    clearText() {
        this.textPart.clearText();
    }


    // widget menu

    setBackgroundColor(color) {
        this.backgroundColor = color;
        if (lightOrDark(this.backgroundColor) == "light") {
            this.textPart.menuTextColor("black", true, false);
        } else {
            this.textPart.menuTextColor("white", true, false);
        }
    }




    // states

    getState(fixType) {
        var state = {};

        switch (fixType) {
            case "props": // нельзя для widget menu сохранять full, так как сохраняется width
                state["UID"] = this.UID;
                state["backgroundColor"] = this.backgroundColor;
                state["alignment"] = this.alignment;
                state["textPart"] = this.textPart.getState("full");
                state["sectionWidth"] = this.sectionWidth || 1;
                break;
            case "full":
                state["UID"] = this.UID;
                state["width"] = this.width;
                state["height"] = this.height; // на будущее
                state["backgroundColor"] = this.backgroundColor;
                state["alignment"] = this.alignment;
                state["textPart"] = this.textPart.getState("full");
                state["sectionWidth"] = this.sectionWidth;
                break;

        }

        return state;
    }

    loadState(stateObj, fixType) {
        switch (fixType) {
            case "props":
                this.UID = getStringProperty("UID", stateObj);
                this.alignment = getStringProperty("alignment", stateObj);
                this.textPart.loadState(stateObj["textPart"], "full");
                this.setBackgroundColor(getColorProperty("backgroundColor", stateObj)); // лучше ставить после загрузки текста
                this.sectionWidth = getNumberProperty("sectionWidth", stateObj, 1);
                break;
            case "full":
                this.UID = getStringProperty("UID", stateObj);
                this.width = getNumberProperty("width", stateObj);
                this.height = getNumberProperty("height", stateObj);
                this.alignment = getStringProperty("alignment", stateObj);
                this.textPart.loadState(stateObj["textPart"], "full");
                this.setBackgroundColor(getColorProperty("backgroundColor", stateObj)); // лучше ставить после загрузки текста
                this.sectionWidth = getNumberProperty("sectionWidth", stateObj, 1);
                break;
        }
    }



    UID = "";
    textPart = null;
    height = 50;
    width = 200;
    startX = 0;
    startY = 0;

    sectionWidth = 1;

    backgroundColor = "#FFFFFF";
    alignment = "left";


    // constants
    horizontalPadding = 20;
    verticalPadding = 20;
}
